var map = {
	"./decidim/avatar-multiuser.png": 57120,
	"./decidim/brands/facebook.svg": 87262,
	"./decidim/brands/google.svg": 1151,
	"./decidim/brands/twitter-x.svg": 24692,
	"./decidim/cc-badge.png": 94730,
	"./decidim/decidim-logo.svg": 48770,
	"./decidim/default-avatar.svg": 96702,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 92962,
	"./decidim/icons.svg": 63745,
	"./decidim/pattern.png": 61358,
	"./decidim/placeholder-card-g.svg": 32963,
	"./decidim/placeholder-card-l.svg": 9832,
	"./decidim/placeholder.jpg": 65503,
	"./decidim/remixicon.symbol.svg": 48884,
	"./decidim/vendor/social-share-button/douban.svg": 71798,
	"./decidim/vendor/social-share-button/email.svg": 13907,
	"./decidim/vendor/social-share-button/facebook.svg": 3717,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 24575,
	"./decidim/vendor/social-share-button/hacker_news.svg": 31815,
	"./decidim/vendor/social-share-button/linkedin.svg": 84827,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 69060,
	"./decidim/vendor/social-share-button/pinterest.svg": 47413,
	"./decidim/vendor/social-share-button/reddit.svg": 92837,
	"./decidim/vendor/social-share-button/telegram.svg": 54812,
	"./decidim/vendor/social-share-button/tumblr.svg": 62051,
	"./decidim/vendor/social-share-button/twitter.svg": 50290,
	"./decidim/vendor/social-share-button/vkontakte.svg": 12108,
	"./decidim/vendor/social-share-button/wechat.svg": 50855,
	"./decidim/vendor/social-share-button/whatsapp.svg": 34439,
	"./decidim/vendor/social-share-button/x.svg": 6227,
	"./decidim/vendor/social-share-button/xing.svg": 67061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64079;